<template>
    <div class="TelephoneCharge">
        <div class="bgBox"><img src="./../../../../assets/usercenter/bg-getmoney.png" alt=""></div>
        <div class="top"></div>
        <div class="header">
            <router-link to="/home/getmoney" tag="i"> <img src="./../../../../assets/home/back.jpg" alt=""> </router-link>
            <span>话费充值</span>
        </div>
        <div class="userInfo">
            <span>{{Tel}}</span>
        </div>
        <div class="moneyArea">
            <div
                v-for = "(item,index) in items" 
                :key="item.index"
                :class = "active == index ? 'addclass' : '' " 
                @click='dowm(index, $event)'>
            <span class="out">{{item.number}}<span class="in">元</span></span>
            </div>
        </div>
        <div class="nowMoney">
            <div class="imgBox"><img src="./../../../../assets/usercenter/circle.png" alt=""></div>
            <p class="nowMoneyTitle">当前余额<span class="nowMoneyNumber"> {{balance}} </span>元</p>
        </div>
        <div class="takeMoney" @click="getMoney">立即充值</div>
        <Rule @status="getStatus"></Rule>
    </div>
</template>

<script>
import Rule from "@/components/Rule"
export default {
    components:{
        Rule,
    },
    data(){
        return {
            items :[
                {number :'10',},
                {number :'20',},
                {number :'30',},
                {number :'50',},
                {number :'100',},
                {number :'200',},
                {number :'400',},
            ],
            active : -1,
            number : null,
            balance: this.$route.query.money,
            Tel:localStorage.getItem("UserTELNumber")
        }
    },
    methods:{
        dowm(index, $event){
            //将点击的元素的索引赋值给变量
            this.active = index
            this.number = parseInt(event.currentTarget.innerText)
        },
        getStatus(val){
            this.status = val
        },
        getMoney(){
            let _this = this
            if(_this.number === null){
                alert("请输入充值金额")
            }else{
                if(_this.status === false){
                    let moneyNumber = _this.number
                    if(confirm("是否提现" + moneyNumber + "元")){
                        function setupWebViewJavascriptBridge(callback) {                                            
                            if (window.WebViewJavascriptBridge) { 
                                return callback(WebViewJavascriptBridge); 
                            }       
                            if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
                            window.WVJBCallbacks = [callback];                                                        
                            var WVJBIframe = document.createElement('iframe');                                        
                            WVJBIframe.style.display = 'none';                                                        
                            WVJBIframe.src = 'https://__bridge_loaded__';                                             
                            document.documentElement.appendChild(WVJBIframe);                                                
                            setTimeout(function() { 
                                document.documentElement.removeChild(WVJBIframe) 
                            }, 0)                  
                        }                                                                                                      
                        setupWebViewJavascriptBridge(function(bridge) { 
                            bridge.callHandler('encrypt', {
                                uid : localStorage.getItem("UID"),
                                account : localStorage.getItem("UserTELNumber"),
                                token : localStorage.getItem("UserToken"),
                                realname : null,
                                type : 1,
                                money : moneyNumber,
                                request_time : Date.parse(new Date())
                            }, function(response) {
                                let userInfoCode = response.dataReq
                                let userInfoSign = response.dataSign
                                _this.$axios.post("/api/user/widthdraw", {      
                                    code : userInfoCode,
                                    dataSign : userInfoSign,
                                }).then(res=>{
                                    alert(res.data.msg)
                                    if(res.data.status === 1){
                                        _this.$router.go(-1)
                                    }
                                })
                            })
                        })
                    }
                }else{
                    alert("请勾选同意用户协议")
                }
            } 
        },
    },
}
</script>
<style lang="scss" scoped>
    
    .bgBox{
        width:100%;
        height:2.06rem;
        position: absolute;
        right:0;
        top:.60rem;
        z-index: -1;
        img{
            border-radius: 0  .30rem .30rem;
        }
    }
    .top{
        height:.2rem;
    }
    .header{
        width:90%;
        height:.40rem;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
        span{
            font-size: .18rem;
            line-height: .40rem;
        }
        i{
            position:absolute;
            left:0.05rem;
            width:.26rem;
            height:.16rem;
            padding-right:.16rem;
        }
    }
    .userInfo{
        width:90%;
        height:1.20rem;
        margin: 0 auto;
        padding:.15rem 0;
        display: flex;
        align-items: center;
        span{
            height:.80rem;
            width:100%;
            background-color:transparent;
            border:none;
            font-size: .30rem;
            color:#fff;
            border-bottom:.01rem solid #FFF;
            font-weight: bold;
            opacity:0.7;
            line-height: .80rem;
        }
    }
    .moneyArea{
        width:90%;
        height:2.40rem;
        background: #FFF;
        border-radius: .10rem;
        margin: 0 auto;
        padding:.10rem .15rem;
        display:flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap:wrap;
        div{
            width:30%;
            height:25%;
            border:.01rem solid #D8D8D8;
            border-radius:.05rem;
            display:flex;
            align-items: center;
            justify-content: center;
            color:#D8D8D8;
            .out{
                font-size: .18rem;
            }
            .in{
                font-size: .14rem;
            }
        }
    }
    .nowMoney{
        width:90%;
        height:.18rem;
        margin:0 auto;
        display: flex;
        align-items: center;
        margin-top:.20rem;
        .imgBox{
            padding-left: .15rem;
            width:.22rem;
            height:.07rem;
        }
        .nowMoneyTitle{
            margin-left:.10rem;
            color:#9B9B9B;
            font-size: .12rem;
            .nowMoneyNumber{
                color:#AA6B04;
                font-size: .12rem
            }
        }
    }
    .takeMoney{
        width:90%;
        height:.44rem;
        margin:.20rem auto;
        background-image: linear-gradient(112deg, #FFDF42 0%, #FFEC77 100%);
        border-radius: .21rem;
        text-align: center;
        line-height: .44rem;
        font-size: .20rem;
    }
    .moneyArea .addclass{
        background:url("./../../../../assets/usercenter/checked.png") no-repeat center;
        background-size:100% 100%;
        border:none;
        color:#4A4A4A;
    }
</style>

